import React from 'react';

import Header from '../components/layout/header/header';
import SEO from '../components/seo/seo';
import StrapiText from '../components/text/strapi-markdown-text-snippet';

import { StateLandingPageQuery } from '../models/strapi/stateLandingPageQuery';
import { LayoutProps } from '../models/layout';

import * as styles from './footerPage.module.scss';
import Footer from '../components/layout/footer/footer';

interface Props extends LayoutProps {
    pageContext: {
        data?: string;
        title: string;
        stateTemplateStrapiData: StateLandingPageQuery;
        stateAbbrv: string;
    };
}

export default function FooterTemplate(props: Props) {
    const strapiData = props.pageContext;
    return (
        <div>
            <SEO title={strapiData && strapiData.title ? strapiData.title : ''} />
            <Header
                siteTitle={`Curaleaf ${strapiData.stateAbbrv}`}
                mobileMenuOpen={props.mobileMenuOpen}
                toggleMobileMenu={props.toggleMobileMenu}
                data={strapiData.stateTemplateStrapiData.header}
                closeAllMenus={props.closeAllMenus}
                usingMouse={props.usingMouse}
                setMobileMenu={props.setMobileMenu}
            />
            <div className={`content-container ${styles.footerContainer}`}>
                <StrapiText
                    data={{
                        textAlign: 'left',
                        value: strapiData.data,
                        fontColor: 'black',
                        font: 'tradeGothic'
                    }}
                />
            </div>
            <Footer
                data={props.pageContext.stateTemplateStrapiData.footer}
                usingMouse={props.usingMouse}
            />
        </div>
    );
}
